import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";

import UserIcon from "@mui/icons-material/PersonAddAlt1";
import SubjectIcon from "@mui/icons-material/PsychologyAlt";
import { Box, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import gtag from "ga-gtag";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import * as BotpressAPI from "../../data/api/omniBotpressAPI.js";
import {
  createNewOmniAudit,
  createNewUser,
  createNewUserRelationship,
  validateUserODM,
} from "../../data/omniDataModel";
import * as BotpressSessionActions from "../../state/redux/botpressSession.js";
import { deepCopyObject } from "../../utils/helpers";
import { isValidEmail } from "../../utils/helpers";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniPhoneNumberField from "../ui/omniPhoneNumberField";
import OmniTextField from "../ui/omniTextField";

const WizardAssessmentParticipants = props => {
  const {
    onboardingODM,
    userODM,
    awsGroup,
    proxyPatientODM,
    subjectODM = null,
    partnerPatients = [],
    providerPatients = [],
    selfAssessment = false,
    botpressAssessment = false,
    botpressBotODM = null,
    setBotAssessmentStateRequest,
  } = props;

  //#region subject
  const [assessmentSubject, setAssessmentSubject] = useState(
    awsGroup !== constants.userGroups.Provider ? "myself" : "newUser",
  );
  const [assessmentSubjectODM, setAssessmentSubjectODM] = useState(createNewUser(true));
  const [readySubjectData, setReadySubjectData] = useState(false);
  const [givenNameValidSubject, setGivenNameValidSubject] = useState(false);
  const [familyNameValidSubject, setFamilyNameValidSubject] = useState(false);

  //#endregion

  //#region onboardingUser
  const createOnboardingUser = () => {
    let newUserODM = createNewUser(true);
    if (
      onboardingODM != null &&
      onboardingODM.omniData.inviteType === constants.inviteType.single
    ) {
      for (var prop in newUserODM.omniData) {
        if (Object.prototype.hasOwnProperty.call(onboardingODM.omniData.userData, prop)) {
          newUserODM.omniData[prop] = onboardingODM.omniData.userData[prop];
        }
      }
    }

    return newUserODM;
  };

  const [onboardingUserODM, setOnboardingUserODM] = useState(
    !userODM && onboardingODM ? createOnboardingUser : null,
  );

  const [readyOnboardingUserData, setReadyOnboardingUserData] = useState(false);
  const [givenNameValidOnboardingUser, setGivenNameValidOnboardingUser] = useState(false);
  const [familyNameValidOnboardingUser, setFamilyNameValidOnboardingUser] = useState(false);
  const [mobilePhoneValidOnboardingUser, setMobilePhoneValidOnboardingUser] = useState(false);
  const [emaliValidOnboardingUser, setEmaliValidOnboardingUser] = useState(false);
  //#endregion

  const updateAssessmentOnboardingUserODM = event => {
    try {
      let editedUserODM = deepCopyObject(onboardingUserODM);
      editedUserODM.omniData[event.target.id] = event.target.value;
      editedUserODM.omniData["displayName"] =
        `${editedUserODM.omniData.givenName} ${editedUserODM.omniData.familyName}`;
      setOnboardingUserODM(deepCopyObject(editedUserODM));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (onboardingUserODM != null) {
      onboardingUserODM.omniData.givenName
        ? setGivenNameValidOnboardingUser(true)
        : setGivenNameValidOnboardingUser(false);

      // Check family name
      onboardingUserODM.omniData.familyName
        ? setFamilyNameValidOnboardingUser(true)
        : setFamilyNameValidOnboardingUser(false);

      // Check mobile phone
      onboardingUserODM.omniData.mobilePhone &&
      RegExp(/^\D*(\d\D*){10}$/).exec(onboardingUserODM.omniData.mobilePhone)
        ? setMobilePhoneValidOnboardingUser(true)
        : setMobilePhoneValidOnboardingUser(false);

      // Check email
      isValidEmail(onboardingUserODM.omniData.email)
        ? setEmaliValidOnboardingUser(true)
        : setEmaliValidOnboardingUser(false);
    }
  }, [onboardingUserODM]);

  useEffect(() => {
    givenNameValidOnboardingUser &&
    familyNameValidOnboardingUser &&
    mobilePhoneValidOnboardingUser &&
    emaliValidOnboardingUser
      ? setReadyOnboardingUserData(true)
      : setReadyOnboardingUserData(false);
  }, [
    givenNameValidOnboardingUser,
    familyNameValidOnboardingUser,
    mobilePhoneValidOnboardingUser,
    emaliValidOnboardingUser,
  ]);
  //#endregion

  ///All above VALIDATED-----------------------------------

  const updateAssessmentSubjectODM = event => {
    try {
      let editedUserODM = deepCopyObject(assessmentSubjectODM);
      editedUserODM.omniData[event.target.id] = event.target.value;
      editedUserODM.omniData.displayName = `${editedUserODM.omniData.givenName} ${editedUserODM.omniData.familyName}`;
      setAssessmentSubjectODM(deepCopyObject(editedUserODM));
    } catch (error) {
      console.log(error);
    }
  };

  // Check given name
  useEffect(() => {
    assessmentSubjectODM.omniData.givenName
      ? setGivenNameValidSubject(true)
      : setGivenNameValidSubject(false);
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentSubjectODM.omniData.givenName]);

  // Check family name
  useEffect(() => {
    assessmentSubjectODM.omniData.familyName
      ? setFamilyNameValidSubject(true)
      : setFamilyNameValidSubject(false);
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentSubjectODM.omniData.familyName]);

  useEffect(() => {
    givenNameValidSubject && familyNameValidSubject
      ? setReadySubjectData(true)
      : setReadySubjectData(false);
  }, [givenNameValidSubject, familyNameValidSubject]);
  //#endregion

  const onAcceptHandler = () => {
    if (onboardingUserODM) {
      //ONBOARDING CASE
      if (onboardingUserODM.omniData.displayName.length === 0) {
        onboardingUserODM.omniData.displayName = `${onboardingUserODM.omniData.givenName} ${onboardingUserODM.omniData.familyName}`;
      }
      if (assessmentSubjectODM.omniData.displayName.length === 0) {
        assessmentSubjectODM.omniData.displayName = `${assessmentSubjectODM.omniData.givenName} ${assessmentSubjectODM.omniData.familyName}`;
      }
      props.setAssessmentProctorODM(onboardingUserODM);

      if (assessmentSubject === "myself") {
        gtag("event", "omni_assessment_subject_selected", { subject_is_proctor: true });
        assessmentSubjectODM.omniData["isProxyPatient"] = true;
        //this will be blank so lets marshal over all the shit we can
        assessmentSubjectODM.omniData.displayName = onboardingUserODM.omniData.displayName;
        assessmentSubjectODM.omniData.givenName = onboardingUserODM.omniData.givenName;
        assessmentSubjectODM.omniData.familyName = onboardingUserODM.omniData.familyName;
        assessmentSubjectODM.omniData.birthdate = onboardingUserODM.omniData.birthdate;
        assessmentSubjectODM.omniData.gender = onboardingUserODM.omniData.gender;
        assessmentSubjectODM.omniData.race = onboardingUserODM.omniData.race;
        assessmentSubjectODM.omniData.ethnicity = onboardingUserODM.omniData.ethnicity;
        assessmentSubjectODM.omniData.email = onboardingUserODM.omniData.email;
        assessmentSubjectODM.omniData.mobilePhone = onboardingUserODM.omniData.mobilePhone;

        props.setAssessmentSubjectODM(assessmentSubjectODM);
      } else {
        gtag("event", "omni_assessment_subject_selected", { subject_is_proctor: false });
        props.setAssessmentSubjectODM(assessmentSubjectODM);
      }
    } else {
      //VALID USER CASE
      props.setAssessmentProctorODM(userODM);

      if (assessmentSubject === "myself") {
        if (botpressAssessment && false) {
          BotpressAPI.createUser({ botODM: botpressBotODM }).then(response => {
            //save response to the redux state, as a assessment user variable

            const userKey = response.key;
            //now try the create conversation
            BotpressAPI.createConversation({ botODM: botpressBotODM, key: response.key }).then(
              response2 => {
                const conversationId = response2.conversation.id;

                let theParameters = {
                  conversationId: conversationId,
                  userKey: userKey,
                };

                setBotAssessmentStateRequest(theParameters);

                if (proxyPatientODM == null) {
                  //create proxy patient
                  let currentUserCloneODM = deepCopyObject(userODM);
                  currentUserCloneODM.omniData.patientData = {};
                  currentUserCloneODM.omniData.providerData = null;
                  currentUserCloneODM.omniData.partnerData = null;
                  currentUserCloneODM.omniData.administratorData = null;

                  let newProxyPatientODM = validateUserODM(currentUserCloneODM);

                  currentUserCloneODM.omniAudit = createNewOmniAudit();
                  delete currentUserCloneODM.omniData["cognitoUserId"];
                  currentUserCloneODM.omniData.providerData = null;
                  currentUserCloneODM.omniData.partnerData = null;
                  currentUserCloneODM.omniData.administratorData = null;
                  currentUserCloneODM.omniAudit = null;

                  newProxyPatientODM._id = null;
                  delete newProxyPatientODM["id"];

                  let newRelationship = createNewUserRelationship(
                    userODM,
                    constants.omniRelationshipTypes.proxyPatient,
                  );

                  newProxyPatientODM.omniRelationships.relatedData.push(newRelationship);

                  props.setAssessmentSubjectODM(newProxyPatientODM);
                } else {
                  props.setAssessmentSubjectODM(proxyPatientODM);
                }
              },
            );
          });
        } else {
          if (proxyPatientODM == null) {
            //create proxy patient
            let currentUserCloneODM = deepCopyObject(userODM);
            currentUserCloneODM.omniData.patientData = {};
            currentUserCloneODM.omniData.providerData = null;
            currentUserCloneODM.omniData.partnerData = null;
            currentUserCloneODM.omniData.administratorData = null;

            let newProxyPatientODM = validateUserODM(currentUserCloneODM);

            currentUserCloneODM.omniAudit = createNewOmniAudit();
            delete currentUserCloneODM.omniData["cognitoUserId"];
            currentUserCloneODM.omniData.providerData = null;
            currentUserCloneODM.omniData.partnerData = null;
            currentUserCloneODM.omniData.administratorData = null;
            currentUserCloneODM.omniAudit = null;

            newProxyPatientODM._id = null;
            delete newProxyPatientODM["id"];

            let newRelationship = createNewUserRelationship(
              userODM,
              constants.omniRelationshipTypes.proxyPatient,
            );

            newProxyPatientODM.omniRelationships.relatedData.push(newRelationship);

            props.setAssessmentSubjectODM(newProxyPatientODM);
          } else {
            props.setAssessmentSubjectODM(proxyPatientODM);
          }
        }
        gtag("event", "omni_assessment_subject_selected", { subject_is_proctor: true });
      } else if (assessmentSubject === "newUser") {
        props.setAssessmentSubjectODM(assessmentSubjectODM);
        gtag("event", "omni_assessment_subject_selected", { subject_is_proctor: false });
      } else {
        let selectedPatient = null;
        if (awsGroup === constants.userGroups.Provider) {
          selectedPatient = providerPatients.find(patient => patient._id === assessmentSubject);
        } else if (awsGroup === constants.userGroups.Partner) {
          selectedPatient = partnerPatients.find(patient => patient._id === assessmentSubject);
        }

        if (typeof selectedPatient != "undefined") {
          props.setAssessmentSubjectODM(selectedPatient);
        }
        gtag("event", "omni_assessment_subject_selected", { subject_is_proctor: false });
      }
    }
  };

  const onCancelHandler = () => {
    props.onCancel();
  };

  useEffect(() => {
    if (userODM != null && subjectODM != null) {
      props.setAssessmentProctorODM(userODM);
      props.setAssessmentSubjectODM(subjectODM);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userODM, subjectODM]);

  const theme = useTheme();

  return (
    <Fragment>
      <DialogContent>
        {onboardingUserODM && !botpressAssessment && (
          // ONBOARDING ASSESSMENT CASE
          <Grid container direction="row" spacing={1} justifyContent="center">
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  webkitUserSelect: "none",
                  userSelect: "none",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    width: "100%",
                  }}
                >
                  {onboardingODM.omniData.inviteType === constants.inviteType.single
                    ? "Welcome, is your information correct?"
                    : "Welcome, what is your contact info?"}
                </Typography>
                <UserIcon sx={{ marginRight: theme.spacing(1), width: 32, height: 32 }} />
              </Box>
            </Grid>

            <Grid container item spacing={1} xs={12} direction="row">
              <Grid item xs={6} sm={6}>
                <OmniTextField
                  label="First"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"givenName"}
                  value={onboardingUserODM.omniData.givenName}
                  error={!givenNameValidOnboardingUser}
                  onChange={event => {
                    updateAssessmentOnboardingUserODM(event);
                  }}
                  placeholder={"First Name"}
                  required
                />
              </Grid>

              <Grid item xs={6} sm={6}>
                <OmniTextField
                  label="Last"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"familyName"}
                  value={onboardingUserODM.omniData.familyName}
                  error={!familyNameValidOnboardingUser}
                  onChange={event => {
                    updateAssessmentOnboardingUserODM(event);
                  }}
                  placeholder={"Last Name"}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={8}>
                <OmniTextField
                  label="Email"
                  type="textField"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"email"}
                  value={onboardingUserODM.omniData.email}
                  error={!emaliValidOnboardingUser}
                  onChange={event => {
                    updateAssessmentOnboardingUserODM(event);
                  }}
                  placeholder={"Primary Email Address"}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <OmniPhoneNumberField
                  label="Mobile Number"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"mobilePhone"}
                  value={onboardingUserODM.omniData.mobilePhone}
                  error={!mobilePhoneValidOnboardingUser}
                  onChange={event => {
                    updateAssessmentOnboardingUserODM(event);
                  }}
                  onFocus={event => event.target.select()}
                  placeholder={"Your Phone Number"}
                  required
                />
              </Grid>
            </Grid>

            {!selfAssessment && (
              <Grid item xs={12}>
                <Divider
                  sx={{
                    borderRadius: "4px",
                    height: "1px",
                    width: "100%",
                    marginBottom: 0,
                    marginTop: 0,
                  }}
                />
              </Grid>
            )}

            {!selfAssessment && (
              <Grid item container xs={12}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      webkitUserSelect: "none",
                      userSelect: "none",
                      marginTop: 0,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        width: "100%",
                      }}
                    >{`Who is having their health assessed?`}</Typography>
                    <SubjectIcon sx={{ marginRight: theme.spacing(1), width: 32, height: 32 }} />
                  </Box>
                </Grid>

                <Grid item xs={6}>
                  <OmniTextField
                    label="Candidate"
                    select
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"assessmentSubject"}
                    value={assessmentSubject}
                    onChange={event => {
                      setAssessmentSubject(event.target.value);
                    }}
                    placeholder={"Select Trial Candidate"}
                    required
                  >
                    {awsGroup !== constants.userGroups.Provider && (
                      <OmniMenuItem key={"myself"} value={"myself"}>
                        {"Myself"}
                      </OmniMenuItem>
                    )}

                    {awsGroup === constants.userGroups.Partner &&
                      partnerPatients.map(patient => {
                        if (proxyPatientODM && patient._id === proxyPatientODM._id) {
                          return null;
                        }
                        return (
                          <OmniMenuItem key={patient._id} value={patient._id}>
                            {patient.omniData.displayName}
                          </OmniMenuItem>
                        );
                      })}
                    {awsGroup === constants.userGroups.Provider &&
                      providerPatients.map(patient => {
                        if (proxyPatientODM && patient._id === proxyPatientODM._id) {
                          return null;
                        }

                        return (
                          <OmniMenuItem key={patient._id} value={patient._id}>
                            {patient.omniData.displayName}
                          </OmniMenuItem>
                        );
                      })}
                    <OmniMenuItem key={"newUser"} value={"newUser"}>
                      {"Someone Else"}
                    </OmniMenuItem>
                  </OmniTextField>
                </Grid>
              </Grid>
            )}

            {!selfAssessment && assessmentSubject !== "myself" && (
              <Grid container item spacing={1} xs={12} direction="row">
                <Grid item xs={6} sm={6}>
                  <OmniTextField
                    label="First"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"givenName"}
                    value={assessmentSubjectODM.omniData.givenName}
                    error={!givenNameValidSubject}
                    onChange={event => {
                      updateAssessmentSubjectODM(event);
                    }}
                    placeholder={"First Name"}
                    required
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <OmniTextField
                    label="Last"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"familyName"}
                    value={assessmentSubjectODM.omniData.familyName}
                    error={!familyNameValidSubject}
                    onChange={event => {
                      updateAssessmentSubjectODM(event);
                    }}
                    placeholder={"Last Name"}
                    required
                  />
                </Grid>
              </Grid>
            )}
            {!selfAssessment && assessmentSubject === "myself" && (
              <Grid container item spacing={1} xs={12} direction="row">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    webkitUserSelect: "none",
                    userSelect: "none",
                    minHeight: "120px",
                  }}
                ></Box>
              </Grid>
            )}

            {/* <Typography
              variant="caption text"
              sx={{
                // width: "100%",
                marginBottom: `-${theme.spacing(2)}`,
                color: alpha(theme.palette.commonground.contrastText, 0.55),
              }}
            >{`Only our doctors and trial runners will use this info.`}</Typography> */}
          </Grid>
        )}

        {!onboardingUserODM && !botpressAssessment && (
          // USER ASSESSMENT CASE
          <Grid container direction="row" spacing={1} justifyContent="center">
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    webkitUserSelect: "none",
                    userSelect: "none",
                    marginTop: 0,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      width: "100%",
                    }}
                  >{`Who is having their health assessed?`}</Typography>
                  <SubjectIcon sx={{ marginRight: theme.spacing(1), width: 32, height: 32 }} />
                </Box>
              </Grid>

              <Grid item xs={6}>
                <OmniTextField
                  label="Candidate"
                  select
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"assessmentSubject"}
                  value={assessmentSubject}
                  onChange={event => {
                    setAssessmentSubject(event.target.value);
                  }}
                  placeholder={"Select Trial Candidate"}
                  required
                >
                  {/* {awsGroup !== constants.userGroups.Provider && ( */}
                  <OmniMenuItem key={"myself"} value={"myself"}>
                    {"Myself"}
                  </OmniMenuItem>
                  {/* )} */}

                  {!selfAssessment &&
                    awsGroup === constants.userGroups.Partner &&
                    partnerPatients.map(patient => {
                      if (proxyPatientODM && patient._id === proxyPatientODM._id) {
                        return null;
                      }
                      return (
                        <OmniMenuItem key={patient._id} value={patient._id}>
                          {patient.omniData.displayName}
                        </OmniMenuItem>
                      );
                    })}
                  {/* {!selfAssessment && */}
                  {awsGroup === constants.userGroups.Provider &&
                    providerPatients &&
                    providerPatients.map(patient => {
                      if (proxyPatientODM && patient._id === proxyPatientODM._id) {
                        return null;
                      }

                      return (
                        <OmniMenuItem key={patient._id} value={patient._id}>
                          {patient.omniData.displayName}
                        </OmniMenuItem>
                      );
                    })}
                  <OmniMenuItem key={"newUser"} value={"newUser"}>
                    {"Someone Else"}
                  </OmniMenuItem>
                </OmniTextField>
              </Grid>
            </Grid>

            {assessmentSubject === "newUser" && (
              <Grid container item spacing={1} xs={12} direction="row">
                <Grid item xs={6} sm={6}>
                  <OmniTextField
                    label="First"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"givenName"}
                    value={assessmentSubjectODM.omniData.givenName}
                    error={!givenNameValidSubject}
                    onChange={event => {
                      updateAssessmentSubjectODM(event);
                    }}
                    placeholder={"First Name"}
                    required
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <OmniTextField
                    label="Last"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"familyName"}
                    value={assessmentSubjectODM.omniData.familyName}
                    error={!familyNameValidSubject}
                    onChange={event => {
                      updateAssessmentSubjectODM(event);
                    }}
                    placeholder={"Last Name"}
                    required
                  />
                </Grid>
              </Grid>
            )}
            {assessmentSubject !== "newUser" && (
              <Grid container item spacing={1} xs={12} direction="row">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    webkitUserSelect: "none",
                    userSelect: "none",
                    minHeight: "120px",
                  }}
                ></Box>
              </Grid>
            )}

            {/* <Typography
              variant="caption text"
              sx={{
                // width: "100%",
                marginBottom: `-${theme.spacing(2)}`,
                color: alpha(theme.palette.commonground.contrastText, 0.55),
              }}
            >{`Only our doctors and trial runners will use this info.`}</Typography> */}
          </Grid>
        )}
        {botpressAssessment && (
          // USER ASSESSMENT CASE
          <Grid container direction="row" spacing={1} justifyContent="center">
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    webkitUserSelect: "none",
                    userSelect: "none",
                    marginTop: 0,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      width: "100%",
                    }}
                  >{`Show Current Bot Information`}</Typography>
                  <SubjectIcon sx={{ marginRight: theme.spacing(1), width: 32, height: 32 }} />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Grid container direction="row-reverse" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Button
              onClick={e => {
                onAcceptHandler();
              }}
              disabled={
                (userODM == null && !readyOnboardingUserData) ||
                (assessmentSubject === "newUser" && !readySubjectData)
              }
              color="secondary"
              variant="contained"
            >
              {"Start"}
            </Button>
          </Grid>

          <Grid item>
            <Button
              sx={
                userODM == null
                  ? {
                      display: "none",
                    }
                  : {}
              }
              onClick={() => {
                onCancelHandler();
              }}
              color="secondary"
              variant="contained"
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  partnerPatients: state.partnerSession.partnerPatients,
  providerPatients: state.providerSession.providerPatients,
  awsGroup: state.userSession.awsGroup,
  userODM: state.userSession.userODM,
  proxyPatientODM: state.userSession.proxyPatientODM,
  onboardingODM: state.onboardingSession.onboardingODM,
  botpressBotODM: state.botpressSession.botpressBotODM,
});

const mapDispatchToProps = {
  setBotAssessmentStateRequest: BotpressSessionActions.setBotAssessmentStateRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardAssessmentParticipants);
